module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-It.da5ea72.eot";